//配置路由的地方
import Vue from "vue";
import VueRouter from "vue-router";
//使用插件
Vue.use(VueRouter);
//引入路由组件
import whatsNew from "@/pages/whatsNew";
import cakes from "@/pages/cakes";
import iceCream from "@/pages/iceCream";
import mobileApp from "@/pages/mobileApp";
import gift from "@/pages/gift";
import order from "@/pages/order";



const router = new VueRouter({
    routes:[
        {
            path:'/whatsNew',
            component:whatsNew
        },
        {
            path:'/cakes',
            component:cakes
        },
        {
            path:'/iceCream',
            component:iceCream
        },
        {
            path:'/mobileApp',
            component:mobileApp
        },
        {
            path:'/gift',
            component:gift
        },
        {
            name:"order",
            path:'/order',
            meta: {
                requireAuth: true,
            },
            component:order
        },
        {
            path:'/store',
            component:()=>import("@/pages/store")
        },
        {   
            name:"orderDetail",
            meta: {
                requireAuth: true
            },
            path:'/order/orderDetail',
            component:()=>import("@/pages/order/orderDetail")
        },
        {   
            name:"login",
            path:'/login',
            component:()=>import("@/pages/login")
        },
        {   
            name:"chooseLocation",
            path:'*',         
            meta:{
                removeFooter:true
            },
            component:()=>import("@/pages/chooseLocation")
        },        
        {   
            name:"orderSuccess",
            path:'/order/orderSuccess',         
            component:()=>import("@/pages/order/orderSuccess")
        },
        {   
            name:"orderList",
            path:'/center/orderList',         
            component:()=>import("@/pages/center/orderList")
        },
        {   
            name:"centerOrderDetail",
            path:'/center/orderDetail',         
            component:()=>import("@/pages/center/orderDetail")
        },
    ]
})
  
export default router
  